import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { InsertCompanyRecord } from "../_models/insertCompanyRecord";
import { AppConfigService } from "./appConfigService";

@Injectable()
export class XrmService {
  public apiUrl: string;
  public templateAccountNumber: string;
  private httpOptions: object;

  constructor(
    private httpClient: HttpClient,
    appConfigService: AppConfigService
  ) {
    this.apiUrl = appConfigService.crmApiUrl;
    this.templateAccountNumber = appConfigService.templateAccountNumber;
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization:
          `Basic ` +
          btoa(
            `${appConfigService.crmAPIUser}:${appConfigService.crmAPIPassword}`
          ),
      }),
    };
  }

  /* Creates new Contact */
  insertCompanyRecord(insertCompanyRecord: InsertCompanyRecord) {
    insertCompanyRecord.companyFromTemplateInsert.accountNumber =
      this.templateAccountNumber;
    return this.httpClient.post(
      `${this.apiUrl}/InsertCompanyRecord`,
      insertCompanyRecord,
      this.httpOptions
    );
  }
}
